import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBankItemClick, trackBankListShow } from './tracking';
import { BankList } from '../../components/BankList';
import { selectBanks } from '../../selectors/promosPage';

export const BankListContainer: React.FC = () => {
  const bankList = useSelector(selectBanks);

  if (bankList.length === 0) {
    return null;
  }

  return <BankList banks={bankList} onListShow={trackBankListShow} onItemClick={trackBankItemClick} />;
};
